import { render } from "./policy.vue?vue&type=template&id=3429e3ca&scoped=true"
const script = {}

import "./policy.vue?vue&type=style&index=0&id=3429e3ca&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3429e3ca"]])

export default __exports__